import { graphql } from '../../__generated__';

export const DELETE_ADDRESS = graphql(`
  mutation DeleteAddress($addressId: String!) {
    zellarClientDeleteAddress(addressId: $addressId) {
      deletedAddressId
    }
  }
`);
